import keyMirror from "key-mirror";

export const STATE_STATUS = keyMirror({
    UNFETCHED: null,
    FETCHING: null,
    FETCHED: null,
    FETCH_FAILED: null,
    UPDATING: null,
    UPDATED: null,
    UPDATE_FAILED: null,
    INSTANTIATED: null,
    CREATING: null,
    CREATED: null,
    CREATE_FAILED: null,
    UPLOADING: null,
    UPLOADED: null,
    UPLOAD_FAILED: null,
    IDLE: null,
    ENGAGED: null,
    NOT_FOUND: null
});
